import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  () => ({
    root: {
      padding: 0,
    },
  }),
  { name: 'BaseItemsList' }
);
